import { render, staticRenderFns } from "./AdditionalImageEdit.vue?vue&type=template&id=61582b92&scoped=true"
import script from "./AdditionalImageEdit.vue?vue&type=script&lang=js"
export * from "./AdditionalImageEdit.vue?vue&type=script&lang=js"
import style0 from "./AdditionalImageEdit.vue?vue&type=style&index=0&id=61582b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61582b92",
  null
  
)

export default component.exports